import React from 'react'
import { Provider } from 'react-redux'
import {
  IndexRoute,
  Router,
  Route,
  browserHistory,
  Redirect
} from 'react-router'
import configureStore from '../store/configureStore'
import { syncHistoryWithStore } from 'react-router-redux'
import { getRouteName } from './helpers'
import {
  FaqsContainer,
  VideosContainer,
  AppContainer,
  GuidesContainer,
  SingleGuideContainer,
  TutorialsContainer,
  SpecsContainer,
  TutorialsEmbedContainer,
  ExpressHelpContainer,
  HomeContainer,
  NotFound,
  KendraContainer
} from '../containers'
import { createEvent } from '../containers/UserEvents/actions'
import { handleUpdate } from '../containers/InitializeGA'
import { useGAContext } from '../contexts/GAContext'

const store = configureStore()
const history = syncHistoryWithStore(browserHistory, store)
const getName = getRouteName(store)

const getHomeName = getName.bind(null, 'home')
const getGuidesName = getName.bind(null, 'guides')
const getFaqsName = getName.bind(null, 'faqs')
const getVideosName = getName.bind(null, 'videos')
const getTutorialsName = getName.bind(null, 'tutorials')
const getStartName = getName.bind(null, 'start')
const getExpressHelpName = getName.bind(null, 'expresshelp')
const getKendraName = getName.bind(null, 'kendra')
const routes = (
  <Route path="/" component={AppContainer}>
    <IndexRoute
      component={HomeContainer}
      onEnter={getHomeName}
      onChange={getHomeName}
    />
    <Route
      path="devicehome"
      component={SpecsContainer}
      onEnter={getHomeName}
      onChange={getHomeName}
    />
    <Route
      path="devicepicker"
      component={HomeContainer}
      onEnter={getStartName}
      onChange={getStartName}
    />
    <Route
      path="home/*"
      component={SpecsContainer}
      onEnter={getHomeName}
      onChange={getHomeName}
    />
    <Route
      path="page/*"
      component={SpecsContainer}
      onEnter={getHomeName}
      onChange={getHomeName}
    />
    <Route
      path="company/*"
      component={SpecsContainer}
      onEnter={getHomeName}
      onChange={getHomeName}
    />
    <Route
      path="tutorial/*"
      component={SpecsContainer}
      onEnter={getHomeName}
      onChange={getHomeName}
    />
    <Route
      path="user/*"
      component={SpecsContainer}
      onEnter={getHomeName}
      onChange={getHomeName}
    />
    <Route
      path="device/*"
      component={SpecsContainer}
      onEnter={getHomeName}
      onChange={getHomeName}
    />
    <Route path="guides" onEnter={getGuidesName} onChange={getGuidesName}>
      <IndexRoute component={GuidesContainer} />
      <Route path=":id" component={SingleGuideContainer} />
    </Route>
    <Route
      path="faqs"
      component={FaqsContainer}
      onEnter={getFaqsName}
      onChange={getFaqsName}
    >
      <Route path=":faqId" onEnter={getFaqsName} onChange={getFaqsName} />
    </Route>
    <Route
      path="videos"
      component={VideosContainer}
      onEnter={getVideosName}
      onChange={getVideosName}
    >
      <Route path=":videoId" onEnter={getVideosName} onChange={getVideosName} />
    </Route>
    <Route
      path="tutorials"
      onEnter={getTutorialsName}
      onChange={getTutorialsName}
    >
      <IndexRoute component={TutorialsContainer} />
      <Route path=":id" component={TutorialsContainer} />
      <Route path=":category/:id" component={TutorialsContainer} />
      <Route path="embed/:id" component={TutorialsEmbedContainer} />
    </Route>
    <Redirect from="landing" to="/" />
    <Redirect from="getstarted" to="/" />
    <Route
      path="expresshelp"
      component={ExpressHelpContainer}
      onEnter={getExpressHelpName}
      onChange={getExpressHelpName}
    >
      <Route
        path=":category(/:id)"
        onEnter={getExpressHelpName}
        onChange={getExpressHelpName}
      />
    
    </Route>
    <Route
      path="kendra"
      component={KendraContainer}
      onEnter={getKendraName}
      onChange={getKendraName}
    >

    </Route>
    <Route path="404" component={NotFound} />
    <Redirect from="*" to="/404" state={{ origin: window.location.href, referrer: document.referrer }} />
  </Route>
)

const Routes = () => {
  const { initialized } = useGAContext()
  return (
    <Provider store={store}>
      <React.Fragment>
        <Router
          onUpdate={() => {
            // Use to check if google analytics have been initialized
            if (initialized) {
              handleUpdate(store.getState())
              store.dispatch(createEvent({ category: 'pageviews' }))
            }
          }}
          history={history}
        >
          {routes}
        </Router>
      </React.Fragment>
    </Provider>
  )
}

export default Routes



// WEBPACK FOOTER //
// ./src/routes/Routes.js